
import { Vue, Component, Prop } from 'vue-property-decorator';
import { CostBreakdownDataType } from '@/features/dashboard/types';

@Component
export default class DataTypeSwitch extends Vue {
  @Prop({ required: true }) currentType!: keyof typeof CostBreakdownDataType;
}
